<template>
  <div>
    <div class="d-flex justify-center" style="text-align: center">
      <span class="h1">{{ name }} Membership Payment </span>
    </div>
    <div
      class="pb-2  px-5"
      style="text-align: center"
    >
      <span v-if="instructorRenewalMembership">Enter your billing details to renew your Instructor Membership.</span><span v-else>Enter your billing details. The membership fee is billed annually until
        cancelled. You may update billing details or membership level any time
        from your profile.</span>
    </div>
    <!-- <div class="px-15 pt-5 d-flex justify-center">
      <span style="color: red; font-size: 20px; font-weight: 700">
        76 Days until next renewal date.
      </span>
    </div> -->

    <!-- <div class="pt-3 d-flex justify-center" style="text-align: center">
      <span>
        To upgrade your membership before your renewal date, return to your
        membership management page to complete the upgrade process separately.
      </span>
    </div> -->
    <div class="mt-3">
      <v-card outlined flat>
        <v-card flat color="#F2F2F2" outlined>
          <v-row class="px-4 pb-4 align-center">
            <v-col cols="12" md="6">
              <v-radio-group
                class="mt-0"
                hide-details
                v-model="selectedPaymentMethod"
              >
                <v-radio
                  class="mt-0"
                  label="Pay with Credit Card"
                  color="#58C7C6"
                  value="one"
                ></v-radio>
                <!-- value="Pay with Card" -->
              </v-radio-group>
            </v-col>
            <v-col cols="12" md="6" class="payment-logo">
              <div class="d-flex justify-center">
                <!-- <visaiconsvg /> -->
                <img
                  class="credit-card-logo-img payment-logo-img"
                  src="/img/Credit-Card-Logos4.png"
                  contain
                />
              </div>
            </v-col>
          </v-row>
        </v-card>
        <!-- <v-card flat color="#F2F2F2" class="mt-2" outlined>
          <v-row class="px-4 pb-4 align-center">
            <v-col cols="12" md="8">
              <v-radio-group
                hide-details
                v-model="selectedPaymentMethod"
                class="mt-0"
              >
                <v-radio
                  class="mt-0"
                  label="Pay with PayPal"
                  color="#58C7C6"
                  value="two"
                ></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="12" md="4" class="payment-logo">
              <div class="payment-logo-img d-flex pl-2">
                <paypalsvg />
              </div>
            </v-col>
          </v-row>
        </v-card> -->

        <!-- <div v-if="$v.form.CheckoutType.$error" class="error-text">
          Select the payment option
        </div> -->
        <div class="mt-4 pa-4">
          <div v-if="selectedPaymentMethod === 'one' || getDetailCard">
            <p><b>Name on Card</b></p>
            <v-text-field
              dense
              label="Card Holder Name"
              v-model="form.CardHolderName"
              single-line
              outlined
              :error-messages="
                getErrorMessageCardHolderName(form?.CardHolderName)
              "
            ></v-text-field>
            <!-- :error-messages="
              $v.form.CardHolderName.$error
                ? 'CardHolderName field is required'
                : null
            " -->
            <!-- hint="Enter name as it appears on the Card" -->
            <!-- persistent-hint -->
            <p><b>Card Number</b></p>
            <v-text-field
              label="Card Number"
              v-model="form.CardNumber"
              dense
              outlined
              :error-messages="getErrorMessageCardNumber(form.CardNumber)"
              single-line
              maxlength="16"
            ></v-text-field>
          </div>
          <div
            v-if="selectedPaymentMethod === 'one' || getDetailCard"
            class="exp-cvv"
          >
            <div class="exp-sub">
              <p><b>Expiration Date</b></p>
              <v-text-field
                class=""
                label="MM/YY"
                maxlength="5"
                v-model="form.ExpiryDate"
                dense
                outlined
                single-line
                @input="formatExpiryDate"
                :error-messages="getErrorMessageExpiryDate(form.ExpiryDate)"
              ></v-text-field>
            </div>

            <div class="exp-sub">
              <p><b>CVV</b></p>
              <v-text-field
                class=""
                label="CVV"
                v-model="form.CVV"
                dense
                outlined
                :maxlength="form.CardNumber?.length === 15 ? 4 : 3"
                :error-messages="getErrorCardNumberCvv(form.CVV)"
                single-line
              ></v-text-field>
            </div>
          </div>
          <div v-if="getDetailCard == undefined">
            <div v-if="CountryOnIP !== 'Brazil' && CountryOnIP !== 'Japan'">
              <p class="mb-0"><b>Discount Code</b></p>
              <v-row class="font-16">
                <v-col cols="12" md="8">
                  <div>
                    <input
                      type="text"
                      v-model="ValidateCouponCode"
                      class="searchfield"
                    />
                  </div>
                </v-col>
                <v-col cols="12" md="4" align-self="center">
                  <span
                    class="primary-text link"
                    v-if="loader != true"
                    @click="ValidateCoupon"
                    >Validate</span
                  >
                  <v-progress-circular
                    v-else
                    indeterminate
                    size="20"
                    class="px-5"
                    color="blacl"
                    v-show="loader"
                  ></v-progress-circular>
                </v-col>
              </v-row>
            </div>
            <!-- <v-text-field
              label="Card Number"
              v-model="form.CardNumber"
              dense
              outlined
              :error-messages="getErrorMessageCardNumber(form.CardNumber)"
              single-line
              maxlength="16"
            ></v-text-field> -->
            
            <div class="my-3" v-if="!instructorRenewalMembership">
              Discounts apply to the first year of membership, after which the
              full membership price will be billed.
            </div>
            <div v-if="instructorRenewalMembership" class="d-flex align-center gap-4 mt-3">
              <div><b>Instructor Membership:</b></div>
              <div>$300.00</div>
            </div>
            <div v-else class="d-flex align-center gap-4 mt-3">
              <div><b>Membership Price:</b></div>
              <div>${{ NoninstructorManageMembership ? (manageNonInstructorMembership.memebershipId == 2 ? 40 : manageNonInstructorMembership.memebershipId == 3 ? 150 : manageNonInstructorMembership.memebershipId == 4 ? 300 : manageNonInstructorMembership.memebershipId == 5 ? 300 : 0)?.toFixed(2) : isAdd ? (membershipAmountId == 2 ? 40 : membershipAmountId == 3 ? 150 : 0) : this.form.AmountPaid?.toFixed(2) }}</div>
            </div>
            <div v-if="NoninstructorManageMembership" class="d-flex align-center gap-4 mt-1">
              <div><b>Prorated adjustment:</b></div>
              <div>${{ calculateProratedAdjustment?.toFixed(2) }}
              </div>
            </div>
            <div class="d-flex align-center gap-4 mt-1">
              <div><b>Discount:</b></div>
              <div>${{ this.couponDiscount?.toFixed(2) }}</div>
            </div>
            <div v-if="CountryOnIP == 'Japan' || CountryOnIP == 'Brazil'" class="d-flex align-center gap-4 mt-1">
              <div><b>{{CountryOnIP}} Discount:</b></div>
              <div>${{ countryDiscount }}</div>
            </div>
            <div v-if="instructorRenewalMembership" class="d-flex align-center gap-4 mt-1">
              <div><b>License Fee:</b></div>
              <div>${{ licenseFee?.toFixed(2) }}</div>
              <!-- <div>${{ (this.GetLicensingDetails?.TotalLicencingFees)?.toFixed(2) }}</div> -->
              
            </div>
            <div v-if="instructorRenewalMembership" class="d-flex align-center gap-4 mt-1">
              <div><b>Total Credits Earned:</b></div>
              <div>${{ totalCreditsEarned?.toFixed(2) }}</div>
              <!-- <div>${{ (this.GetLicensingDetails?.TotalCreditsEarned)?.toFixed(2) }}</div> -->
            </div>
            
            <div class="d-flex align-center gap-4 mt-1">
              <div><b>Total Price:</b></div>
              <div v-if="NoninstructorManageMembership" >${{ adjustedTotalPrice }}</div>
              <div v-else>${{ addDiscountPrice }}</div>
            </div>
            
          </div>
        </div>
      </v-card>
      <!-- <v-card flat color="#F2F2F2" class="mt-5" outlined>
        <v-row class="px-4">
          <v-col cols="12" md="10">
            <v-radio-group v-model="ex7" class="mt-0">
              <v-radio
                class="mt-0"
                label="Pay with PayPal"
                color="#58C7C6"
                value="Pay with PayPal"
              ></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12" md="2">
            <div class="d-flex justify-center mt-2">
              <paypalsvg />
            </div>
          </v-col>
        </v-row>
      </v-card> -->
    </div>
    <div class="mt-8">
      <div class="d-flex justify-end">
        <div class="pr-2">
          <v-btn
            large
            color="gray"
            outlined
            depressed
            class=""
            @click="cancel"
          >
            <span class="">cancel</span>
          </v-btn>
        </div>
        <div class="pl-2">
          <v-btn
            large
            color="primary"
            depressed
            :disabled="btnloader"
            class=""
            @click="submitForm()"
          >
            <span class="" v-if="btnloader != true">confirm</span>
            <v-progress-circular
              v-else
              indeterminate
              size="20"
              class="px-5"
              color="white"
              v-show="btnloader"
            ></v-progress-circular>
          </v-btn>
        </div>
      </div>
    </div>
    <!----------------------Confirm dialoag---------------------->
    <v-dialog v-model="ConfirmDialog" persistent max-width="700">
      <v-card class="px-8 py-4">
        <div class="d-flex justify-end">
          <v-icon @click="ConfirmDialog = false">mdi-close</v-icon>
        </div>
        <div class="pt-4 d-flex justify-center" style="text-align: center">
          <span class="h1">
            <b>
              Well done. Your membership is now set up for auto-renewals.
            </b></span
          >
        </div>
        <div
          class="pt-4 d-flex justify-center"
          style="text-align: center; font-size: 1.5rem"
        >
          Cancel auto-renewals anytime by <br />
          returning to your membership <br />
          management page and switching auto-<br />renewals off.
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {
  required,
  minLength,
  // maxLength,
  numeric,
  alpha,
} from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import { defineComponent } from "vue";
//import downgradecomponents from "../../components/Profile/membershipcomponents/downgradecomponents.vue"
import visaiconsvg from "../../../assets/SvgIcons/visaiconsvg.vue";
import paypalsvg from "../../../assets/SvgIcons/paypalsvg.vue";
import { mapGetters } from "vuex";

const alphaWithSpacesAndSpecialChars = (value) => {
  // return /^[A-Za-z\s]+$/.test(value);    //to allow spaces
  // return /^[A-Za-z\s!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+$/.test(value); //to allow spaces and special characters
  return /^[A-Za-z\s!@#$%^&*()_+\-=\[\]{};'’:"\\|,.<>/?áàãâäåāăąçćĉċčðďèéêëēĕėęěĝğġģĥħìíîïĩīĭįıĵķĺļľłńņňŋòóôõöøōŏőœñŕŗřśŝşšţťŧùúûüũūŭůűųŵýÿŷźżžÁÀÃÂÄÅĀĂĄÇĆĈĊČÐĎÈÉÊËĒĔĖĘĚĜĞĠĢĤĦÌÍÎÏĨĪĬĮİĴĶĹĻĽŁŃŅŇŊÒÓÔÕÖØŌŎŐŒŔŖŘŚŜŞŠŢŤŦÙÚÛÜŨŪŬŮŰŲŴÝŸŶŹŻŽ\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FFF\uFF66-\uFF9F]+$/.test(value);
  // to allow spaces, special char, latin char, japanese characters (Kanji, Hiragana and Katakana scripts).
};

const allowDigitsAndSteric = (value) => {
  if (!value) return true;
  return /^[0-9*]+$/.test(value); // to allow digits and *
};
export default defineComponent({
  components: { visaiconsvg, paypalsvg },
  props: [
    "membershipAmountId",
    "membershipAmount",
    "autoRewNewl",
    "isAdd",
    "getDetailCard",
    "name",
    "formData",
    "manageMembership",
    "manageNonInstructorMembership",
    "instructorRenewalMembership",
    "NoninstructorManageMembership",
    "membershipPrice",
    "licenseFee",
    "totalCreditsEarned",
    "countryDiscount",
    "prevMembershipPriceOnLocationDiscount"
  ],
  mixins: [validationMixin],
  
  watch: {
    // form: {
    //   handler(newVal) {
    //     if (this.getDetailCard) {
    //       if (
    //         (newVal.CardNumber?.startsWith("*") &&
    //           newVal.CardNumber !==
    //             this.getBillingDetailsByUserId.Data?.CardNumber) ||
    //         (newVal.ExpiryDate?.startsWith("*") &&
    //           newVal.ExpiryDate !==
    //             this.getBillingDetailsByUserId.Data?.ExpiryDate) ||
    //         (newVal.CVV?.startsWith("*") &&
    //           newVal.CVV !== this.getBillingDetailsByUserId.Data?.CVV) ||
    //         (newVal.CardHolderName?.startsWith("*") &&
    //           newVal.CardHolderName !==
    //             this.getBillingDetailsByUserId.Data?.CardHolderName)
    //       ) {
    //         this.form.CardHolderName = "";
    //         this.form.CardNumber = "";
    //         this.form.ExpiryDate = "";
    //         this.form.CVV = "";
    //       }
    //     }
    //   },
    //   deep: true,
    // },
  },
  data() {
    return {
      isFormSubmitted: false,
      remainingMonths: 0,
      currentMembershipPrice: 150,
      discountOnCountryOfResidence: 0,
      CountryOnIP: "",
      DiscountType: 0,
      ValidateCouponCode: "",
      btnloader: false,
      selectedPaymentMethod: "one",
      userId: null,
      membershipId: null,
      isSolo: true,
      isSolo1: true,
      isSolo3: true,
      dateValid: false,
      closedailog: false,
      ConfirmDialog: false,
      downgradedialogpopup: false,
      downgradedialog: false,
      radio: "one",
      form: {
        UserId: this.userId != undefined ? this.userId : 0,
        isNewAccount: false,
        AmountPaid:
          this.membershipAmount != undefined
            ? this.membershipAmount[this.membershipAmountId - 1].amount
            : 0,
        CheckoutType: 1,
        MembershipId: 0,
        UserMembershipId:
          this.membershipId != undefined ? this.membershipId : 0,
        CardHolderName: "",
        CardNumber: null,
        ExpiryDate: null,
        CVV: null,
        Coupon: null,
        proratedAdjustment: 0,
        MembershipLocation:null,
        LocationDiscount: 0,
        LicensingFee: 0,
        TotalCreditsEarned: 0,
      },
      loader: false,
      couponDiscount: 0,
    };
  },
  // watch: {
  //   selectedPaymentMethod(newValue, oldValue) {
  //     if (newValue === "card") {
  //       this.form.Payment.PaymentType = "1"; // Set value for payment type for card
  //     } else if (newValue === "paypal") {
  //       this.form.Payment.PaymentType = "2"; // Set value for payment type for paypal
  //     }
  //   },
  // },
  validations: {
    form: {
      CardHolderName: { required, alpha: alphaWithSpacesAndSpecialChars },
      CardNumber: {
        required,
        allowDigitsAndSteric: allowDigitsAndSteric,
        minLength: minLength(15),
        // checkCardNumber(value) {
        //   return /^(4[0-9]{15}?)$/.test(value);
        // },
      },
      ExpiryDate: {
        required,
        expiryDate(value) {
          
          if (!value) {
            return "Expiry date is required.";
          }
          if (value.includes("*")) {
            return true; // Skip validation if it's still masked
          }

          const [month, year] = value.split("/");
          if (!month || !year || isNaN(month) || isNaN(year)) {
            return false; // Ensure valid numbers
          }

          const currentDate = new Date();
          const currentYear = currentDate.getFullYear() % 100;
          const currentMonth = currentDate.getMonth() + 1;

          return parseInt(month) >= 1 &&
                parseInt(month) <= 12 &&
                parseInt(year) >= currentYear &&
                ((parseInt(year) === currentYear && parseInt(month) >= currentMonth) || parseInt(year) > currentYear);
        }
        // expiryDate(value) {
          
        //   if (!value) {
        //     return "Expiry date is required.";
        //   }

        //   const [month, year] = value.split("/");
        //   const currentDate = new Date();
        //   const currentYear = currentDate.getFullYear() % 100;
        //   const currentMonth = currentDate.getMonth() + 1;

        //   if (
        //     parseInt(month) >= 1 &&
        //     parseInt(month) <= 12 &&
        //     parseInt(year) >= currentYear &&
        //     ((parseInt(year) === currentYear &&
        //       parseInt(month) >= currentMonth) ||
        //       parseInt(year) > currentYear)
        //   ) {
        //     return true;
        //   } else {
        //     return false;
        //   }
        // },
      },
      CVV: {
        required,
        allowDigitsAndSteric: allowDigitsAndSteric,
        minLength: minLength(3),
      },
      
    },
  },
  computed: {
    ...mapGetters(["getBillingDetailsByUserId", "GetUser","GetLicensingDetails","getMembershipByUserId"]),
    addDiscountPrice() {
      if (this.instructorRenewalMembership) {
        return (300 + (this.licenseFee || 0) - 
              (this.totalCreditsEarned || 0) - 
              this.couponDiscount - 
              this.countryDiscount)?.toFixed(2);
      }
      // return ((this.membershipPrice ? this.membershipPrice : this.form.AmountPaid) - this.couponDiscount - this.discountOnCountryOfResidence).toFixed(2);
      const membership = this.membershipPrice ? this.membershipPrice : this.isAdd ? (this.membershipAmountId == 2 ? 40 : this.membershipAmountId == 3 ? 150 : 0) : this.form.AmountPaid;
      const coupon = this.couponDiscount ?? 0;
      const countryDiscount = this.countryDiscount;
      
      return (membership - coupon - countryDiscount)?.toFixed(2);
    },
    adjustedTotalPrice() {
      if (this.NoninstructorManageMembership) {
        return (this.membershipPrice - this.calculateProratedAdjustment - this.couponDiscount).toFixed(2);
      }
      return this.membershipPrice?.toFixed(2);
    },
    calculateProratedAdjustment() {
      if (this.NoninstructorManageMembership) {
        
        const priceDifference = this.membershipPrice - (this.getMembershipByUserId.Data.Name === 'Standard' ? (150 - (this.prevMembershipPriceOnLocationDiscount.StandardDiscount)) : this.getMembershipByUserId.Data.Name === 'Access' ? 40 : this.getMembershipByUserId.Data.Name === 'Starter' ? 0 : this.getMembershipByUserId.Data.Name === 'Practitioner' ? (300 - (this.prevMembershipPriceOnLocationDiscount.PractitionerDiscount)) : this.getMembershipByUserId.Data.Name === 'Instructor' ? (300 - (this.prevMembershipPriceOnLocationDiscount.InstructorDiscount)) : 0);
        const monthlyDifference = (Math.floor((priceDifference / 12) * 100) / 100);

        const remainingMonths = Number(this.calculateRemainingMonths(this.$store.getters.getMembershipByUserId.Data?.EndDateTime));
          
        this.form.proratedAdjustment = this.membershipPrice - (monthlyDifference * remainingMonths);
        if(remainingMonths > 0){
            return this.form.proratedAdjustment
          }
        // return this.form.proratedAdjustment;
      }
      return 0;
    },
    
  },
  mounted() {
    this.fetchData();
    this.$store.dispatch("GetMembershipPriceOnUserLocation").then((res)=>{
      if(res?.Status){
        
        this.CountryOnIP = res.Data?.Country;
        this.discountOnCountryOfResidence = this.membershipAmountId == 3 ? res?.Data?.Discount?.StandardDiscount : this.membershipAmountId == 4 ? res?.Data?.Discount?.PractitionerDiscount : this.membershipAmountId == 5 ? res?.Data?.Discount?.InstructorDiscount : 0;
        this.form.LocationDiscount = this.discountOnCountryOfResidence;
      } else {
        this.discountOnCountryOfResidence = 0
      }
    })
    if (this.manageMembership?.isManageMemebership) {
      this.form.AmountPaid = this.manageMembership.amount;
    }
  },
  methods: {
    // calculateRemainingMonths() {
    //   const currentDate = new Date();
    //   const renewalDate = new Date(this.$store.getters.getMembershipByUserId.Data?.EndDateTime);
    //   const totalMonths = (renewalDate.getFullYear() - currentDate.getFullYear()) * 12
    //     + renewalDate.getMonth() - currentDate.getMonth();
    //   return totalMonths > 0 ? totalMonths : 0;
    // },
    calculateRemainingMonths(givenDate) {
      const targetDate = new Date(givenDate);
      const currentDate = new Date();

      const targetYear = targetDate.getFullYear();
      const targetMonth = targetDate.getMonth();
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth();
      const yearDifference = targetYear - currentYear;
      const monthDifference = targetMonth - currentMonth;
      const remainingMonths = yearDifference * 12 + monthDifference;

      return remainingMonths;
    },
    ValidateCoupon() {
      if (this.ValidateCouponCode == "") {
        return;
      }
      var obj = {
        Code: this.ValidateCouponCode,
        Type: "Membership",
      };
      this.loader = true;
      this.$store.dispatch("ValidateCoupon", obj).then((res) => {
        console.log(res.Message);
        if (res.Data) {
          this.form.Coupon = res.Data.Code;
        }
        if (res.Status) {
          this.couponDiscount = res.Data == null ? 0 : res.Data?.DiscountValue;
          this.DiscountType = res.Data == null ? 0 : res.Data?.DiscountType;
          if (this.DiscountType == 1) {
            if(this.instructorRenewalMembership){
              const discount = this.couponDiscount / 100 * 300;
              this.couponDiscount = discount;
            } else if (this.NoninstructorManageMembership){
              const discount = this.couponDiscount / 100 * this.membershipPrice;
              this.couponDiscount = discount;
            } else {
              const discount = this.couponDiscount / 100 * this.form.AmountPaid;
              this.couponDiscount = discount;
            }
            // const discount = this.couponDiscount / 100;
            // this.couponDiscount = this.form.AmountPaid - this.form.AmountPaid * discount;
          }
          this.$swal.fire({
            position: "top-end",
            icon: res.Message == "Valid Coupon" ? "success" : "error",
            title: res.Message,
            showConfirmButton: false,
            timer: 3000,
            toast: true,
          });
          this.loader = false;
        }
      });
    },
    // formatPrice(publicPrice) {
    //   if (publicPrice.toString().includes(".")) {
    //     if (publicPrice.toString().split(".")[1].length === 1) {
    //       return publicPrice.toFixed(2);
    //     }
    //   }
    //   return publicPrice.toFixed(2);
    // },
    formatExpiryDate() {
      if (
        this.form.ExpiryDate.length === 2 &&
        !this.form.ExpiryDate.includes("/")
      ) {
        this.form.ExpiryDate += "/";
      }
    },
    getErrorMessageCardHolderName(field) {
      if (this.$v.form.CardHolderName.$error == false) {
        return null;
      }
      if (!field) {
        return "Card holder name is required";
      }
      if (!this.$v.form.CardHolderName.alpha) {
        return "Only alphabetical characters are allowed.";
      }
      return null;
    },
    getErrorMessageCardNumber(field) {
      if (this.$v.form.CardNumber.$error == false) {
        return null;
      }
      if (field == null || field == "") {
        return "Card number is required";
      }
      if (!this.$v.form.CardNumber.allowDigitsAndSteric) {
        return "Only numeric digits are allowed";
      }
      if (!this.$v.form.CardNumber.minLength) {
        return "Minimum of 15 digits are required";
      }
      return "Invalid card number.";
    },
    // getErrorCardNumberCvv(field){
    //     if (this.$v.form.CVV.$error == false) {
    //       return null;
    //     }
    //     if (field == null || field == "") {
    //       return "CVV is required";
    //     }
    //     if (!this.$v.form.CVV.allowDigitsAndSteric) {
    //       return "Only numeric digits are allowed";
    //     }
    //     if (!this.$v.form.CVV.minLength) {
    //       return "Minimum of 3 digits is required";
    //     }
    //     return "Only numeric digits are allowed.";
    //   },
    getErrorCardNumberCvv(field) {
      // if (this.$v.form.CVV.$error == false) {
      //   return null;
      // }
      if (!this.isFormSubmitted) {
        return null; // Do not show errors if the form hasn't been submitted
      }
      const cardLength = this.form?.CardNumber?.length;
      const validCvvLength = cardLength === 15 ? 4 : 3;

      if (!field) {
        return `CVV is required`;
      }
      if (field.length !== validCvvLength) {
        return `CVV must be ${validCvvLength} digits long`;
      }
      if (!this.$v.form.CVV.allowDigitsAndSteric) {
        return "Only numeric digits are allowed";
      }

      return null;
    },
    getErrorMessageExpiryDate(field) {
      if (this.$v.form.ExpiryDate.$error == false) {
        return null;
      }
      if (!field) {
        return "Expiration date is required";
      }
      return "Invalid Expiration date.";
    },
    close() {
      this.$emit("close");
    },
    cancel() {
      this.$emit("close");
      this.form.proratedAdjustment = 0;
      this.form.CardHolderName = "";
      this.form.CardNumber = null;
      this.form.ExpiryDate = null;
      this.form.CVV = null;
      this.ValidateCouponCode = "";
      this.couponDiscount = 0;
    },
    // replaceMaskedData(input, original) {
    //   if (!input) return original; // If input is empty, return the original value
    //   if (!original) return input; // If no original data exists, return input

    //   let result = "";

    //   for (let i = 0; i < original.length; i++) {
    //     if (i < input.length && input[i] !== "*" && input[i] !== undefined) {
    //       result += input[i]; // Keep user-entered character
    //     } else {
    //       result += original[i]; // Fill in original character
    //     }
    //   }

    //   return result;
    // },
    submitForm() {
      this.isFormSubmitted = true;
      this.$v.form.$touch(); // Trigger validation for all form fields

      if (this.$v.form.$invalid) {
        console.log("Form validation failed");
        return;
      }
      const billingData = this.getBillingDetailsByUserId.Data;

  // Refresh form with latest billing data
  this.form.CardHolderName = this.form?.CardHolderName || billingData?.CardHolderName;
  this.form.CardNumber = this.form?.CardNumber || billingData?.CardNumber;
  this.form.ExpiryDate = this.form?.ExpiryDate || billingData?.ExpiryDate;
  this.form.CVV = this.form?.CVV || billingData?.CVV;

  // Check for unchanged fields
  const unchangedFields = [];

  if (this.form.CardHolderName === billingData?.CardHolderName) {
    unchangedFields.push("Card Holder Name");
  }
  if (this.form.CardNumber === billingData?.CardNumber) {
    unchangedFields.push("Card Number");
  }
  if (this.form.ExpiryDate === billingData?.ExpiryDate) {
    unchangedFields.push("Card Expiry");
  }
  if (this.form.CVV === billingData?.CVV) {
    unchangedFields.push("CVV");
  }

  // If all fields are unchanged, show warning and stop API call
  if (unchangedFields.length > 0) {
    this.$swal.fire({
      position: "top-end",
      icon: "warning",
      title: `Please update: ${unchangedFields.join(", ")}`,
      showConfirmButton: false,
      timer: 3000,
      toast: true,
    });
    return;
  }
      // Determine CVV length based on card number
      const cardLength = this.form?.CardNumber?.length;
      const validCvvLength = cardLength === 15 ? 4 : 3;

      if (this.form.CVV?.length !== validCvvLength) {
        console.log(`CVV must be ${validCvvLength} digits long`);
        return;
      }

      if (this.isAdd) {
        const newFormData = new FormData();
        for (let [key, value] of this.formData.entries()) {
          newFormData.append(key, value === undefined ? '' : value);
        }
          this.form.Coupon = this.ValidateCouponCode
          this.form.AmountPaid = this.form.AmountPaid - this.couponDiscount - this.discountOnCountryOfResidence
          this.form.MembershipLocation = this.CountryOnIP
          this.form.LocationDiscount = this.discountOnCountryOfResidence
        // Append new fields
        newFormData.append("AmountPaid", this.form.AmountPaid);
        newFormData.append("CardHolderName", this.form.CardHolderName);
        newFormData.append("CardNumber", this.form.CardNumber);
        newFormData.append("ExpiryDate", this.form.ExpiryDate);
        newFormData.append("CVV", this.form.CVV);
        newFormData.append("Coupon", this.form.Coupon);
        newFormData.append("MembershipLocation", this.form.MembershipLocation);
        newFormData.append("LocationDiscount", this.form.LocationDiscount);
        this.btnloader = true;
        this.$store.dispatch("SignUp", newFormData).then((res) => {
          this.btnloader = false;
          this.$store.dispatch("resetStateAction");
          this.$store.state.userToken = res.LoginTokenResponseModel.access_token;
          // this.form.UserId = res.UserMemeberships.User?.Id;
          // this.form.UserMembershipId = res.UserMemeberships?.Id;
          // this.form.MembershipId = res.UserMemeberships.MembershipId;
          // this.form.isNewAccount = true;
          // this.form.Coupon = this.ValidateCouponCode
          // this.form.AmountPaid = this.form.AmountPaid - this.couponDiscount - this.discountOnCountryOfResidence
          // this.form.MembershipLocation = this.CountryOnIP
          // this.form.LocationDiscount = this.discountOnCountryOfResidence
          // this.$store.dispatch("MembershipPayment", this.form).then(() => {
            
            
              if(this.$store.state.redirectToPreviousRoute) {
                this.$router.push("/");
                this.$store.state.loginPopup = true;
              } else {
                this.$router.push("/");
              }
              this.$swal.fire({
                position: "top-end",
                icon: "success",
                title: "Account Created Successfully",
                showConfirmButton: false,
                timer: 3000,
                toast: true,
              });
            
          // });
        }).catch((error) => {
          if (error.response && error.response.status === 409) {
            // Email already exists
            this.$swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Email already exists. Please use a different email address.",
            });
          } else if(error.response && error.response.status === 400) {
            console.error("Error:", error);
            this.$swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Payment failed: No valid response received from Authorize.NET.",
            });
          }
          this.btnloader = false;
        });
      }

      if (this.getDetailCard) {
        // const billingData = this.getBillingDetailsByUserId.Data;

        // console.log("Billing Data from Vuex:", billingData); // Log fetched original data
        // console.log("Before Masking:", this.form.CardHolderName, this.form.CardNumber, this.form.ExpiryDate, this.form.CVV); // Log current input

        // if (billingData) {
        //   this.form.CardHolderName = this.replaceMaskedData(this.form.CardHolderName, billingData.CardHolderName);
        //   this.form.CardNumber = this.replaceMaskedData(this.form.CardNumber, billingData.CardNumber);
        //   this.form.ExpiryDate = this.replaceMaskedData(this.form.ExpiryDate, billingData.ExpiryDate);
        //   this.form.CVV = this.replaceMaskedData(this.form.CVV, billingData.CVV);
        // }

        // console.log("Final Payload Before API Call:", this.form); 
        
        delete this.form.AmountPaid;
        delete this.form.CheckoutType;
        delete this.form.MembershipId;
        delete this.form.UserMembershipId;
        this.form.Id = this.getBillingDetailsByUserId.Data?.Id;
        // this.form.Id = billingData?.Id;
        this.form.BillingType = 1;
        this.form.CardType = "Pay with Card";
        this.form.UserId = this.GetUser?.Id;
        this.form.PayPalEmail = null;

        this.$store.dispatch("EditMembershipPayment", this.form).then((res) => {
          this.close();
          if(res.Status){
            this.$swal.fire({
              position: "top-end",
              icon: "success",
              title: "Your billing details for autorenewal have been updated. ",
              showConfirmButton: false,
              timer: 3000,
              toast: true,
            });
          }
        });
      }

      if (this.manageMembership?.isManageMemebership) {
        this.form.UserId = this.GetUser?.Id;
        this.form.UserMembershipId = this.manageMembership.userMembershipId;
        this.form.MembershipId = this.manageMembership.memebershipId;
        this.form.PayPalEmail = "";

        if (this.instructorRenewalMembership) {
          this.btnloader = true;
          const InstructorLevelFee = this.getMembershipByUserId.Data?.InstructorPreviousRecord?.InstructorLevel == 1 ? 100 : this.getMembershipByUserId.Data?.InstructorPreviousRecord?.InstructorLevel == 2 ? 200 : this.getMembershipByUserId.Data?.InstructorPreviousRecord?.InstructorLevel == 3 ? 450 : 0

          const InstructorCreditsEarned = this.GetLicensingDetails?.TotalCreditsEarned || 0

          this.form.MembershipLocation = this.CountryOnIP
          this.form.LocationDiscount = this.countryDiscount
          this.form.LicensingFee = this.licenseFee
          this.form.TotalCreditsEarned = this.totalCreditsEarned
          const amountToPay = (300 - this.countryDiscount) + this.form.LicensingFee - this.form.TotalCreditsEarned - this.couponDiscount;
          this.form.AmountPaid = amountToPay;
          
          
          this.$store.dispatch("InstructorMembershipPayment", this.form).then((res) => {
            this.btnloader = false;
            this.cancel();
            if(res.Status){
              this.$swal.fire({
                position: "top-end",
                icon: "success",
                title: "Instructor Membership Renewed Successfully",
                showConfirmButton: false,
                timer: 3000,
                toast: true,
              });
              window.location.reload();
            } else {
              this.btnloader = false;
              this.$swal.fire({
                position: "top-end",
                icon: "error",
                title: res.Message,
                showConfirmButton: false,
                timer: 3000,
                toast: true,
              });

            }
            // this.$router.push("/membershiprenewalinstructor");
            // const obj = {
            //   id: this.GetUser?.Id,
            // };
            // this.$store.dispatch("GetMembershipByUserId", obj);
            // this.$store.dispatch("GetUserWeb", this.GetUser?.Id);
            // this.$store.dispatch("GetUserLicensingDetails", this.GetUser?.Id);
          });
        }
      } else if (this.manageNonInstructorMembership?.isManageMemebership) {
        this.form.UserId = this.GetUser?.Id;
        this.form.UserMembershipId = this.manageNonInstructorMembership.userMembershipId;
        this.form.MembershipId = this.manageNonInstructorMembership.memebershipId;
        this.form.PayPalEmail = "";

        this.form.AmountPaid =
          this.membershipPrice - this.calculateProratedAdjustment - this.couponDiscount;
        this.form.isNewAccount = false;
        this.form.Coupon = this.ValidateCouponCode
        this.form.MembershipLocation = this.CountryOnIP
        this.form.LocationDiscount = this.discountOnCountryOfResidence
        this.btnloader = true;
        this.$store.dispatch("MembershipPayment", this.form).then((res) => {
          this.cancel();
          this.btnloader = false;
          if(res.Status){
            this.$swal.fire({
              position: "top-end",
              icon: "success",
              title: "Membership Payment Successful",
              showConfirmButton: false,
              timer: 3000,
              toast: true,
            });
            window.location.reload();
          } else {
            this.$swal.fire({
              position: "top-end",
              icon: "error",
              title: res.Message,
              showConfirmButton: false,
              timer: 3000,
              toast: true,
            });
          }
        });
      }
    },
    maskSensitiveData(data, isName = false) {
      if (!data) return null;
      if (isName) {
        return data.replace(/./g, "*");
      }
      return data.replace(/./g, "*");
    },
    maskCardNumber(cardNumber) {
      if (!cardNumber) return null;
      const last4Digits = cardNumber.slice(-4);
      const maskedDigits = cardNumber.slice(0, -4).replace(/\d/g, "*");
      return `${maskedDigits}${last4Digits}`;
    },
    
    fetchData() {
      const obj = {
        id: this.GetUser?.Id,
      };
      if (this.getDetailCard) {
        this.$store.dispatch("GetBillingDetailsByUserId", obj).then(() => {
          this.form.CardHolderName = this.isAdd
            ? ""
            : this.maskSensitiveData(this.getBillingDetailsByUserId.Data?.CardHolderName, true);
          this.form.CardNumber = this.isAdd
            ? null
            : this.maskCardNumber(this.getBillingDetailsByUserId.Data?.CardNumber);
          this.form.ExpiryDate = this.isAdd
            ? null
            : this.maskSensitiveData(this.getBillingDetailsByUserId.Data?.ExpiryDate);
          this.form.CVV = this.isAdd
            ? null
            : this.maskSensitiveData(this.getBillingDetailsByUserId.Data?.CVV);
        });
      }
    },
  },
  
  // method: {
  //   close() {
  //     this.$emit("close");
  //   },
  // },
});
</script>

<style scoped>
.error-text {
  color: red; /* Adjust the color to your preference */
  margin-top: 5px; /* Optional: Adjust the spacing */
}
.searchfield {
  background: #f7f8fc;
  padding: 0.6rem;
  width: 100%;
  border-radius: 7px;
}
.payment-logo {
  padding: 0 12px;
}
.payment-logo-img {
  justify-content: center;
}
.credit-card-logo-img {
  width: 100%;
  height: 40px;
}
@media (min-width: 425px) {
  .credit-card-logo-img {
    width: 250px;
    height: 40px;
  }
}
@media (min-width: 768px) {
  .payment-logo {
    padding: 12px 0;
  }
  .payment-logo-img {
    justify-content: end;
    padding-right: 8px;
  }
  .exp-cvv {
    display: flex;
    gap: 16px;
  }
  .exp-sub {
    flex-basis: 50%;
  }
  .credit-card-logo-img {
    width: 100%;
    height: 40px;
  }
}
</style>
